const ITEMS = [
  "Ristorazione de luxe",
  "Hotellerie sartoriale",
  "Boutique B&B",
  "Botteghe artigiane",
  "Prenotazioni direct",
  "Zero commissioni",
  "SEO locale",
  "Google Maps",
];

function MarqueeRow({ hidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((t) => (
        <span key={t} className="flex shrink-0 items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-tight text-bone/65 md:text-3xl">
            {t}
          </span>
          <span className="text-lg text-terracotta" aria-hidden="true">
            ✦
          </span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="overflow-hidden border-y border-line bg-panel py-7">
      <div className="marquee-track flex w-max" data-testid="marquee-track">
        <MarqueeRow />
        <MarqueeRow hidden />
      </div>
    </section>
  );
}